import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { AuthService } from './_services/auth.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {

    private portId: number = null;
    private slug: string = null;

    constructor(private authService: AuthService, private router: Router, private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
        this.router.events
            .filter(e => e instanceof NavigationEnd)
            .forEach(e => {
                let params = this.activatedRoute.root.firstChild.snapshot.params;

                if (params['portId']) {
                    this.portId = params['portId'];
                    this.slug = params['slug'];
                }
            });
    }

    logout() {
        this.authService.logoutPPA();
        this.authService.logoutAzureAD();
    }

}



// WEBPACK FOOTER //
// ./Angular/app/app.component.ts